var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('nav-bar',{on:{"menu-button-click":_vm.toggleSideBar}}),_c('div',{staticClass:"main-container"},[_c('side-bar',{attrs:{"hidden":_vm.sideBarHidden}}),_c('keep-alive',{attrs:{"exclude":"ConteudoCardLocalizacao"}},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }